import type { IProduct } from "@src/types/AppTypes";
import { createContext } from "react";

export const EmojiContext = createContext<IProduct | null>(null);

export const EmojiDispatchContext = createContext<any>(null);

export function emojiReducer(
  state: IProduct | null,
  action: { payload: IProduct | null; type: "updateEmoji" }
) {
  if (action.type === "updateEmoji") {
    return action.payload;
  } else {
    return state;
  }
}
